import React, { useEffect, useState } from "react";
import { BreadCrumb } from "../../../Components";
import demande from "../../../Assets/Icons/demande-intervention.png";
import PAC from "../../../Assets/Icons/PAC.png";
import search from "../../../Assets/Icons/recherche-tech.png";
//import reclamation from "../../../Assets/Icons/reclamation.png";
import project from "../../../Assets/Icons/suivi-projet.png";
//import contract from "../../../Assets/Icons/contrat-maintenance.png";
import user from "../../../Assets/Icons/ajouter-utilisateurs.png";

const Compte = () => {
  const [entreprise, setEntreprise] = useState("non");

  useEffect(() => {
    setEntreprise(sessionStorage.getItem("entreprise"));
  }, []);

  return (
    <div className="bg-white">
      <BreadCrumb From={""} To={"Mon Compte"} hrefFrom={"#"} />

      {entreprise === "non" && (
        <div className="max-w-screen-xl  ml-auto mr-auto border border-gray-200 rounded-lg mt-10 mb-[8px] grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 p-10">
          <div className="flex justify-center  p-5  h-[200px]">
            <div className="m-auto cursor-pointer ">
              <a href="/new-project">
                <img
                  src={demande}
                  alt="Demander une intervention"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />

                <h3 className="text-center text-[16px] font-bold">
                  Demander une intervention
                </h3>
              </a>
            </div>
          </div>

          <div className="flex justify-center  p-5  h-[200px] border-x border-l border-r border-[#d9d9d9]!important ">
            <div className="m-auto cursor-pointer  ">
              <a href="/recherche">
                <img
                  src={search}
                  alt="Trouver un technicien"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Trouver un technicien
                </h3>
              </a>
            </div>
          </div>

          <div className="flex justify-center  p-5  h-[200px]">
            <div className="m-auto cursor-pointer">
              <a href="/user-history">
                <img
                  src={project}
                  alt="Suivre mes demandes d'intervention"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Suivre mes demandes d'intervention
                </h3>
              </a>
            </div>
          </div>

          <div className="flex justify-center  p-5  h-[200px]">
            <div className="m-auto cursor-pointer">
              <a href="/mes-appareils">
                <img
                  src={PAC}
                  alt="Ajouter un Appareil"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />

                <h3 className="text-center text-[16px] font-bold">
                  Ajouter un Appareil
                </h3>
              </a>
            </div>
          </div>

          {/*<div className="flex justify-center  p-5  h-[200px] border-x ">
            <div className="m-auto cursor-pointer">
              <a href="/contrat">
                <img
                  src={contract}
                  alt="Mes Contrats d’entretien"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />

                <h3 className="text-center text-[16px] font-bold">
                  Mes Contrats d’entretien
                </h3>
              </a>
            </div>
          </div>*/}

          {/*<div className="flex justify-center  p-5  h-[200px]">
            <div className="m-auto cursor-pointer">
              <a href="/reclamations">
                <img
                  src={reclamation}
                  alt="Mes réclamation"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />

                <h3 className="text-center text-[16px] font-bold">
                  Mes réclamations
                </h3>
              </a>
            </div>
      </div>*/}
        </div>
      )}

      {entreprise === "oui" && (
        <div className="max-w-screen-xl  ml-auto mr-auto border border-gray-200 rounded-lg mt-10 mb-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 p-10 ">
          <div className="flex justify-center bg-white p-5 rounded-lg h-[200px]">
            <div className="m-auto cursor-pointer">
              <a href="/nouveau-projet-pro">
                <img
                  src={demande}
                  alt="Ajouter un projet"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Ajouter un projet
                </h3>
              </a>
            </div>
          </div>

          {/* New Feature */} 

          {/*<div className="font-Audrey flex justify-center bg-white p-5 h-[200px] border-l-2 border-r-2 border-gray-200">
            <div className="m-auto cursor-pointer">
              <a href="/nouveau-client-pro">
                <img
                  src={demande}
                  alt="Ajouter un client"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Ajouter un client
                </h3>
              </a>
            </div>
      </div>  

          <div className="flex justify-center bg-white p-5 h-[200px] border-l border-r border-gray-300">
            <div className="m-auto cursor-pointer">
              <a href="/recherche">
                <img
                  src={search}
                  alt="Trouver un technicien"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Trouver un technicien
                </h3>
              </a>
            </div>
          </div> */}

          <div className="flex justify-center bg-white p-5 h-[200px] border-l  border-gray-300">
            <div className="m-auto cursor-pointer">
              <a href="/user-history">
                <img
                  src={project}
                  alt="Suivre mes projets"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Suivre mes projets
                </h3>
              </a>
            </div>
          </div>

          {/*<div className="font-Audrey flex justify-center bg-white p-5 h-[200px] ">
            <div className="m-auto cursor-pointer">
              <a href="/contrat">
                <img
                  src={contract}
                  alt="Mes Contrats d’entretien"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Contrats d’entretien
                </h3>
              </a>
            </div>
          </div>*/}

          {/*<div className="flex justify-center bg-white p-5 h-[200px] border-l  border-gray-300">
            <div className="m-auto cursor-pointer">
              <a href="/reclamations">
                <img 
                  src={reclamation}
                  alt="Mes réclamations"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Réclamations
                </h3>
              </a>
            </div>
        </div>*/}

                  <div className="flex justify-center bg-white p-5 h-[200px] ">
            <div className="m-auto cursor-pointer">
              <a href="/liste-clients">
                <img 
                  src={user}
                  alt="Mes réclamations"
                  className="h-[60px] w-auto ml-auto mr-auto mb-[20px]"
                />
                <h3 className="text-center text-[16px] font-bold">
                  Liste des clients
                </h3>
              </a>
            </div>
        </div>
        </div>
      )}
    </div>
  );
};

export default Compte;